import React from 'react';
import { useMutation } from '@apollo/client';
import GoalSettingsMutation from './GoalSettingsMutation';
import DietSettingsQuery from '../../DietSettings/Fetch/DietSettingsQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ISaveGoalSettingsConnectorApolloProps {
  children: ({
    saveGoalSettings,
  }: {
    saveGoalSettings: (variables: any) => Promise<any>;
  }) => React.ReactElement;
}

const SaveGoalSettingsConnectorApollo: React.FC<ISaveGoalSettingsConnectorApolloProps> = ({
  children,
}) => {
  const today = formatIsoDate(new Date());
  const [saveGoal] = useMutation(GoalSettingsMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: DietSettingsQuery,
        variables: { date: today },
      },
    ],
  });

  const saveGoalSettings = async (variables: any) => {
    const response = await saveGoal({
      variables: { ...variables },
    });

    return response.data.me.goalSettings;
  };
  return children({ saveGoalSettings });
};

export default SaveGoalSettingsConnectorApollo;
